import React from 'react';
import { NewTabLink } from '../components/new-tab-link';
import PageShell from '../components/page-shell';
import LogoStarsBlack from '../svg/logo-stars-black.svg';
import PropTypes from 'prop-types';

export default class PageNotAuthorized extends React.Component {
  render() {
    return (
      <PageShell
        meta={{
          title: 'Page not found',
          description: 'Page not found.',
          pathname: this.props.pathname
        }}
      >
        <div className="py60 flex-parent flex-parent--column">
          <div className="flex-child flex-child--grow align-center">
            <div className="mx-auto pb18" style={{ maxWidth: 150 }}>
              <LogoStarsBlack />
            </div>
            <h1 className="txt-h1-mm txt-h2 txt-fancy">403: Not Authorized</h1>
            <p className="txt-l mb12 mt12">
              Think you should have access?{' '}
              <NewTabLink href="/contact/" className="link">
                Contact us.
              </NewTabLink>
            </p>
          </div>
        </div>
      </PageShell>
    );
  }
}

PageNotAuthorized.propTypes = {
  pathname: PropTypes.string.isRequired
};

export { PageNotAuthorized };
